import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';
import { useAuth } from '../context/AuthContext';

const Checkout = () => {
  const { user, tenant, token } = useAuth();
  const navigate = useNavigate();
  const plan = new URLSearchParams(useLocation().search).get('plan');

  useEffect(() => {
    if (!user || !tenant || !token) {
      navigate(`/login?plan=${plan}`);
      return;
    }

    const startCheckout = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/billing/stripe/checkout`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ plan }),
          }
        );

        if (!res.ok) {
          throw new Error('Stripe checkout failed');
        }

        const { url } = await res.json();
        window.location.href = url;
      } catch (err) {
        console.error(err);
        alert('Checkout failed');
        navigate('/plans');
      }
    };

    startCheckout();
  }, [user, tenant, token, plan, navigate]);

  return null; // Redirect-only page
};

export default Checkout;
